































































































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { ValidationProvider } from 'vee-validate-3';

import TextField from '@/componentsV2/molecules/Inputs/TextField.vue';
import FormHeader from '@/componentsV2/molecules/FormHeader/FormHeader.vue';
import MapPinIcon from '@/components/icons/Pin.vue';
import SelectDropdownField from '@/componentsV2/molecules/SelectDropdownField/SelectDropdownField.vue';
import BulkCheckboxes from '@/componentsV2/organisms/BulkCheckboxes/BulkCheckboxes.vue';
import RadioGroupWithCustom from '@/componentsV2/molecules/Inputs/RadioGroupWithCustom.vue';
import InputWrapper from '@/componentsV2/molecules/Inputs/InputWrapper.vue';

import {
  IOfferLocationItem,
  IOfferMethod,
  IOfferEdit,
  IOfferRedemptionData,
  OfferMethodDictionaryV2 as OfferMethodDictionary,
  SpecialOfferTypeEnum
} from '@/models/offer';

import { IBusinessType } from '@/models/business';
import { VueMultiselectOptions } from '@/models/select-dropdown';

import { removeProtocol } from '@/utils/urlUtils';

import { PromoCodeOption } from '../FormOffer.vue';
import SelectDropDownFieldUtils from '@/utils/selectDropdownFieldUtils';
import flagKeys from '@/constants/flagKeys';

import Typography from '@/componentsV2/atoms/Typography/Typography.vue';
import { IBusiness } from '@/store/modules/managerTypes';

interface IOption<T = string> {
  id: number;
  value: T;
  label: string;
}

let timer: NodeJS.Timeout;

@Component({
  components: {
    TextField,
    FormHeader,
    MapPinIcon,
    SelectDropdownField,
    BulkCheckboxes,
    RadioGroupWithCustom,
    InputWrapper,
    Typography,
    ValidationProvider
  }
})
export default class Redemption extends Vue {
  @Prop() errors!: string[];
  @Prop() offer?: IOfferEdit;
  @Prop() transformedLocations!: IOfferLocationItem[];
  @Prop() shouldShowMethodSelect?: boolean;
  @Prop() shouldShowDiscountCode?: boolean;
  @Prop() shouldShowRedemptionSection?: boolean;
  @Prop() offerBusiness?: IBusiness;

  PromoCodeOption = PromoCodeOption;

  redeemMethodOptions: VueMultiselectOptions[] = [
    {
      label: OfferMethodDictionary[IOfferMethod.INSTORE],
      value: IOfferMethod.INSTORE
    },
    {
      label: OfferMethodDictionary[IOfferMethod.ONLINE],
      value: IOfferMethod.ONLINE
    },
    {
      label: OfferMethodDictionary[IOfferMethod.BOTH],
      value: IOfferMethod.BOTH
    }
  ];

  data: IOfferRedemptionData = {
    selectedLocations: this.transformedLocations,
    redeemMethod: (() => {
      if (!this.offer || !this.offer.method) return this.defaultMethod;

      const method = this.redeemMethodOptions.find(
        m => m.value === (this.offer as IOfferEdit).method
      );
      return method || this.defaultMethod;
    })(),
    discountCode:
      this.offer && this.offer.discountCode ? this.offer.discountCode : '',
    link: {
      [PromoCodeOption.OFFER_WITH_PROMO_CODE]: removeProtocol(
        this.business.website
      ),
      [PromoCodeOption.OFFER_WITHOUT_PROMO_CODE]: ''
    },
    promoCodeOption:
      !this.offer ||
      Object.keys(this.offer).length === 0 ||
      (this.offer && this.offer.discountCode)
        ? PromoCodeOption.OFFER_WITH_PROMO_CODE
        : PromoCodeOption.OFFER_WITHOUT_PROMO_CODE
  };

  offerMethodSelectOptions = {
    ...SelectDropDownFieldUtils.getSelectdropdownPropertiesDefault(),
    searchable: false
  };

  get defaultMethod() {
    let value = IOfferMethod.INSTORE;

    if (this.business.type === IBusinessType.ONLINE) {
      value = IOfferMethod.ONLINE;
    }

    return this.redeemMethodOptions.find(
      method => method.value === value
    ) as IOption<IOfferMethod>;
  }

  get websiteFieldOnOfferCreationIsActivated() {
    return this.flags.includes(flagKeys.websiteFieldOnOfferCreation);
  }

  get locationsValidationRules() {
    if (
      this.business.type !== IBusinessType.ONLINE &&
      this.locationsAmount > 1
    ) {
      return 'required';
    }

    return '';
  }

  get flags() {
    return this.$store.getters['flags/getFlags'] || [];
  }

  get tPrefix() {
    return 'offers.form.redemptionRules';
  }

  get isBirthday() {
    return this.$route.query.type === SpecialOfferTypeEnum.BIRTHDAY;
  }

  get locationsAmount() {
    return this.transformedLocations.length;
  }

  get business() {
    const store = this.$store.getters['business/getBusinessInfo'];

    if (store && store.business) {
      return store.business;
    } else {
      return this.offerBusiness || {};
    }
  }

  onToggle(slug: PromoCodeOption) {
    this.data.promoCodeOption = slug;
    this.setInputFocusOnPromoCodeSection(slug);
  }

  setInputFocusOnPromoCodeSection(slug: PromoCodeOption) {
    timer = setTimeout(() => {
      const containerEl = document.getElementById(slug)!;
      const inputElements = containerEl.querySelectorAll('input');

      const setFocusOnFirstInput = () => {
        const inputEl = containerEl.querySelector('input');

        if (inputEl) inputEl.focus();
      };

      if (slug === PromoCodeOption.OFFER_WITH_PROMO_CODE) {
        const filteredInputElements = Array.from(inputElements).filter(
          input => !input.value
        );

        if (filteredInputElements.length) {
          filteredInputElements[0].focus();

          return;
        }

        setFocusOnFirstInput();

        return;
      }

      setFocusOnFirstInput();
    }, 0);
  }

  @Watch('transformedLocations')
  changedLocations() {
    this.data.selectedLocations = this.transformedLocations;
  }

  @Watch('data', { deep: true })
  changedData(data: any) {
    this.$emit('input', data);
  }

  created() {
    this.$emit('input', this.data);
  }

  beforeDestroy() {
    if (timer) clearTimeout(timer);
  }
}
